
export default {
  name: 'HotLink',

  props: {
    href: {
      type: String,
      default: '#',
    },
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'tertiary'].includes(value),
    },
    label: {
      type: String,
      default: '',
    },
    underline: {
      type: Boolean,
      default: true,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    targetBlank: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    linkClasses() {
      return [
        'hot-link',
        `hot-link--${this.type}`,
        {
          'hot-link--withoutUnderline': !this.underline,
          'hot-link--withoutHover': !this.hover,
        },
      ]
    },
    computedTarget() {
      return this.targetBlank ? '_blank' : '_self'
    },
  },

  methods: {
    handleClick(event) {
      this.$emit('click', event)
    },
  },
}
